/*
  ROUEN TERRE DE HOCKEY — rtdh-theme.js
  Coller dans : En ligne > Thèmes > Modifier le code > Assets > rtdh-theme.js (créer le fichier)
  Puis ajouter dans theme.liquid avant </body> :
  <script src="{{ 'rtdh-theme.js' | asset_url }}" defer></script>
*/

/* ── SCROLL REVEAL ── */
function rtdhInitFadeIn() {
  const obs = new IntersectionObserver((entries) => {
    entries.forEach((e, i) => {
      if (e.isIntersecting) {
        setTimeout(() => e.target.classList.add('visible'), i * 60);
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.08 });
  document.querySelectorAll('.rtdh-fade-in:not(.visible)').forEach(el => obs.observe(el));
}

/* ── ADD TO CART (Shopify AJAX API) ── */
function rtdhAddCart(variantId, productTitle, productImage) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(res => res.json())
  .then(data => {
    rtdhShowToast('🛒 ' + productTitle + ' ajouté au panier !');
    rtdhUpdateCartCount();
  })
  .catch(err => {
    console.error('Erreur ajout panier:', err);
    rtdhShowToast('❌ Erreur — réessaie');
  });
}

/* ── UPDATE CART COUNT ── */
function rtdhUpdateCartCount() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const count = cart.item_count;
      const badges = document.querySelectorAll('.rtdh-cart-count');
      badges.forEach(b => {
        b.textContent = count;
        b.style.display = count > 0 ? 'flex' : 'none';
      });
    });
}

/* ── TOAST ── */
function rtdhShowToast(msg) {
  let toast = document.getElementById('rtdh-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'rtdh-toast';
    toast.style.cssText = `
      position:fixed;bottom:30px;right:30px;z-index:9999;
      background:#1c1600;border:2px solid #f5c800;
      padding:16px 24px;font-family:'Barlow Condensed',sans-serif;
      font-weight:700;font-size:15px;color:#f5c800;
      transform:translateY(120px);opacity:0;
      transition:transform .35s,opacity .35s;
      box-shadow:0 8px 40px rgba(245,200,0,.2);
    `;
    document.body.appendChild(toast);
  }
  toast.textContent = msg;
  toast.style.transform = 'translateY(0)';
  toast.style.opacity = '1';
  clearTimeout(toast._t);
  toast._t = setTimeout(() => {
    toast.style.transform = 'translateY(120px)';
    toast.style.opacity = '0';
  }, 3200);
}

/* ── INIT ── */
document.addEventListener('DOMContentLoaded', () => {
  rtdhInitFadeIn();
  rtdhUpdateCartCount();
});